/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Keen_Puma_LiftInputs */

const en_wild_keen_puma_lift = /** @type {(inputs: Wild_Keen_Puma_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share generally`)
};

const de_wild_keen_puma_lift = /** @type {(inputs: Wild_Keen_Puma_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Freigabe`)
};

/**
* | output |
* | --- |
* | "Share generally" |
*
* @param {Wild_Keen_Puma_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_keen_puma_lift = /** @type {((inputs?: Wild_Keen_Puma_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Keen_Puma_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_keen_puma_lift(inputs)
	return de_wild_keen_puma_lift(inputs)
});